import "./label.scss"

